import { render, staticRenderFns } from "./OrderAmount.vue?vue&type=template&id=65c3a261&scoped=true&"
import script from "./OrderAmount.vue?vue&type=script&lang=js&"
export * from "./OrderAmount.vue?vue&type=script&lang=js&"
import style0 from "./OrderAmount.vue?vue&type=style&index=0&id=65c3a261&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c3a261",
  null
  
)

export default component.exports